// DailySalesSummaryReport.jsx
import React from 'react';
import ReportTemplate from './reportTemplate';

const DailySalesSummaryReport = () => <ReportTemplate reportType="Sales Summary" pageTitle="Daily Sales Summary" csvFilePrefix="daily-sales-summary" />;

export default DailySalesSummaryReport;
